import { render } from "./AdvCreate.vue?vue&type=template&id=6b88ec0a"
import script from "./AdvCreate.vue?vue&type=script&lang=js"
export * from "./AdvCreate.vue?vue&type=script&lang=js"

import "./AdvCreate.vue?vue&type=style&index=0&id=6b88ec0a&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__